import { render, staticRenderFns } from "./abstracts-list.vue?vue&type=template&id=0012e732"
import script from "./abstracts-list.vue?vue&type=script&lang=js"
export * from "./abstracts-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports